import React from 'react';
import { BookmarkIcon } from 'lucide-react';
interface SaveEventButtonProps {
  eventId: number;
  isSaved: boolean;
  onToggleSave: (eventId: number) => void;
}
const SaveEventButton: React.FC<SaveEventButtonProps> = ({
  eventId,
  isSaved,
  onToggleSave
}) => {
  return <button onClick={e => {
    e.preventDefault();
    onToggleSave(eventId);
  }} className={`p-1 transition-colors ${isSaved ? 'text-indigo-600' : 'text-gray-400 hover:text-indigo-500'}`} aria-label={isSaved ? 'Remove from saved events' : 'Save event'} data-id="element-1585" data-mp="2cht0r0o4g1hl">
      <BookmarkIcon className={`h-4 w-4 ${isSaved ? 'fill-current' : ''}`} data-id="element-1586" data-mp="1jqszgxh6dbtm" />
    </button>;
};
export default SaveEventButton;